import {
    Flex, useColorModeValue as colorValue, Heading, Text, Icon
} from '@chakra-ui/react'
import React from 'react'
import { BsPencilSquare } from "react-icons/bs";
import RegisterForm from '../components/register/RegisterForm';

const RegisterFormLayout = () => {
    return (
        <Flex bgColor={colorValue("white", "gray.800")} p={{base:4,md:10}} w={{base:"full",md:"80%"}} mx={{base:1,md:5}} mt="90px" mb="40px" borderRadius={12} shadow="xl" direction="column" align="center">
            <SignUpTitle />
            <RegisterForm />
        </Flex>
    )
}

const SignUpTitle = () => {
    return (
        <Flex direction="column" align="start" w="full">
            <Heading mt={4} color="blue.700"><Icon as={BsPencilSquare} mr={2} />สมัครเข้าใช้งาน</Heading>
            <Text>{process.env.REACT_APP_FULL_NAME}</Text>
        </Flex>
    )
}

const Register = () => {
    return (
        <Flex minH="100vh" bgColor={colorValue("gray.100", "gray.700")} align="center" justify="center">
            <RegisterFormLayout />
        </Flex>
    )
}

export default Register
